/* eslint-disable @typescript-eslint/no-unused-vars */
import {AdminPanelSettings, Apps, Business} from '@mui/icons-material';
import {useState} from 'react';
import {
  Box,
  IconButton,
  MenuItem,
  ListItemIcon,
  Menu,
  Tooltip,
} from '@mui/material';
import {app} from '../../providers/Account';

export const AppsMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRedirection = (newTab: boolean, site: string) => {
    const isLocal = window.location.origin === process.env.LOCAL_INTERNAL_URL;
    const redirectBaseUrl = isLocal
      ? process.env.LOCAL_ACCOUNTS_URL
      : process.env.DS_ACCOUNTS_URL;

    const url = `${redirectBaseUrl}/tenants?site=${site}&continue=/`;

    if (newTab) window.open(url, '_blank');
    else window.location.href = url;
  };

  return (
    <>
      <Box sx={{display: 'flex', alignItems: 'center', textAlign: 'center'}}>
        <Tooltip title="Apps">
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={open ? 'apps-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Apps sx={{fontSize: '1.75em', color: 'white'}} />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="apps-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            marginTop: '10px',
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{horizontal: 'right', vertical: 'top'}}
        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
      >
        <MenuItem
          onClick={() => handleRedirection(false, 'business')}
          onAuxClick={() => handleRedirection(true, 'business')}
        >
          <ListItemIcon>
            <Business fontSize="small" />
          </ListItemIcon>
          Business
        </MenuItem>
        <MenuItem
          onClick={() => handleRedirection(false, 'admin')}
          onAuxClick={() => handleRedirection(true, 'admin')}
        >
          <ListItemIcon>
            <AdminPanelSettings fontSize="small" />
          </ListItemIcon>
          Admin
        </MenuItem>
      </Menu>
    </>
  );
};
